import React from 'react'

function Github() {
  return (
    <div className='github'>
        <img src="http://ghchart.rshah.org/7865ff/mdsahilhussain" alt="mdsahilhussain Github chart" />
    </div>
  )
}

export default Github